import React, { useEffect, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import { useKeenSlider } from "keen-slider/react"
import "keen-slider/keen-slider.min.css"

const motionSection = {
  hidden: {
    opacity: 0,
    // y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      staggerChildren: 0.15,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
      // when: "beforeChildren",
    },
  },
}
const underline = {
  hidden: {
    // opacity: 0,
    width: 0,
  },
  visible: {
    opacity: 1,
    // right: 0,
    width: "100%",
    transition: {
      duration: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const title = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const desc = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const logoCloud = ({ block }) => {
  const { heading, text, logoList, color } = block

  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  const animation = { duration: 10000, easing: (t) => t }
  const [currentSlide, setCurrentSlide] = useState(0)
  const [loaded, setLoaded] = useState(false)
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      loop: true,
      drag: false,
      slides: {
        perView: 4.2,
        spacing: 16,
        origin: "center",
      },
      breakpoints: {
        "(min-width: 768px)": {
          loop: true,
          drag: false,
          slides: { 
            perView: 6, 
            spacing: 16,
            origin: "center",
           },
        },
      },
      initial: 0,
      created(s) {
        setLoaded(true)
        s.moveToIdx(5, true, animation)
      },
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel)
      },
      updated(s) {
        s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
      animationEnded(s) {
        s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
    }
  )

  return (
    <motion.section
      className={"section section--px !py-2" + " " + color}
      // className={color == "default" ? "default" : "alt" }
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
    >
      <div className="md:container max-w-screen-md mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="lg:col-span-3 module-image-text-carousel__content hidden lg:flex items-center">
            <h2 className="w-fit h2 mb-6 relative">
              <motion.div variants={title}>{heading}</motion.div>
              <motion.div
                variants={underline}
                className="section-heading__underline bg-orange-400 h-2 w-full absolute -bottom-4 left-0"
              />
            </h2>
            <motion.p variants={desc}>{text}</motion.p>
          </div>

          <div className="lg:col-span-9 lg:flex lg:flex-col lg:flex-row gap-4 lg:gap-8 justify-center items-center">
            <div className="navigation-wrapper w-full">
              <div ref={sliderRef} className="keen-slider">
                {logoList.map((logo, index) => (
                  <div className="keen-slider__slide text-center">
                    {logo.title && (
                      <h3>{logo.title}</h3>
                    )}
                    <GatsbyImage
                      image={logo.image.asset.gatsbyImageData}
                      alt={logo.image.asset.altText}
                      // width="200"
                      // height="200"
                      loading="eager"
                      objectFit="contain"
                      className="w-[50px] h-[50px] lg:w-[80px] lg:h-[80px]"
                    />
                  </div>
                ))}
              </div>
            </div>
            
          </div>
        </div>
        
      </div>
    </motion.section>
  )
}

export default logoCloud
